import { render, staticRenderFns } from "./applygj.vue?vue&type=template&id=42ec4a7c&scoped=true&"
import script from "./applygj.vue?vue&type=script&lang=js&"
export * from "./applygj.vue?vue&type=script&lang=js&"
import style0 from "./applygj.vue?vue&type=style&index=0&id=42ec4a7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec4a7c",
  null
  
)

export default component.exports